var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingRing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.625 15.6243C14.2819 15.6243 15.625 14.2811 15.625 12.6243C15.625 10.9674 14.2819 9.62427 12.625 9.62427C10.9681 9.62427 9.625 10.9674 9.625 12.6243C9.625 14.2811 10.9681 15.6243 12.625 15.6243Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 13.5043V11.7443C2.625 10.7043 3.475 9.84433 4.525 9.84433C6.335 9.84433 7.075 8.56433 6.165 6.99433C5.645 6.09433 5.955 4.92433 6.865 4.40433L8.595 3.41433C9.385 2.94433 10.405 3.22433 10.875 4.01433L10.985 4.20433C11.885 5.77433 13.365 5.77433 14.275 4.20433L14.385 4.01433C14.855 3.22433 15.875 2.94433 16.665 3.41433L18.395 4.40433C19.305 4.92433 19.615 6.09433 19.095 6.99433C18.185 8.56433 18.925 9.84433 20.735 9.84433C21.775 9.84433 22.635 10.6943 22.635 11.7443V13.5043C22.635 14.5443 21.785 15.4043 20.735 15.4043C18.925 15.4043 18.185 16.6843 19.095 18.2543C19.615 19.1643 19.305 20.3243 18.395 20.8443L16.665 21.8343C15.875 22.3043 14.855 22.0243 14.385 21.2343L14.275 21.0443C13.375 19.4743 11.895 19.4743 10.985 21.0443L10.875 21.2343C10.405 22.0243 9.385 22.3043 8.595 21.8343L6.865 20.8443C5.955 20.3243 5.645 19.1543 6.165 18.2543C7.075 16.6843 6.335 15.4043 4.525 15.4043C3.475 15.4043 2.625 14.5443 2.625 13.5043Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingRing);
export default __webpack_public_path__ + "static/media/setting-ring.d1eebea7.svg";
export { ForwardRef as ReactComponent };